<template>
  <div style="display:flex;">
<span :style="_leftContainerDivStyle" v-show="leftButtons.length" ref="leftSpan" style="flex-wrap: wrap; display: flex;">
  <button
      v-for="(button) in leftButtons"
      style="margin-right: 5px; margin-bottom: 2px;"
      :disabled="button.disabled"
      v-show="button.show"
      :style="button.style || {}"
      @click="button.callback(button)"
      type="button"
      class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
      :ref="'button_' + button.id"
  >
    <span class="dhx_button__text" :class="button.class || {}">{{button.html}}</span>
  </button>
</span>
    <span :style="_containerDivStyle" ref="rightSpan" v-show="rightButtons.length"  style="flex-wrap: wrap; display: flex;">
        <button
            v-for="(button) in rightButtons"
            style="margin-left: 5px;  margin-bottom: 2px;"
            :disabled="button.disabled"
            v-show="button.show"
            :style="button.style || {}"
            @click="buttonClick($event, button)"
            type="button"
            class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
            :ref="'button_' + button.id"
        >
            <span class="dhx_button__text" :class="button.class || {}">{{button.html}}</span>
        </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    buttons: Array,
    containerDivStyle: {
      default(){ return {}; },
      type: Object
    },
    leftContainerDivStyle: {
      default(){ return {}; },
      type: Object
    }
  },
  computed: {
    rightButtons() {
      return this.buttons.filter(e => ((typeof e.orientation === "undefined") || (e.orientation && e.orientation === "right")));
    },
    leftButtons() {
      return this.buttons.filter(e => (e.orientation && e.orientation === "left"));
    },
    _containerDivStyle() {
      return Object.assign({
        'display': this.rightButtons.length ? 'flex' : 'none',
        'justify-content': 'flex-end',
        'flex-grow': 1
      }, this.containerDivStyle);
    },
    _leftContainerDivStyle() {
      return Object.assign({
        'display': this.leftButtons.length ? 'flex' : 'none',
        'justify-content': 'flex-start',
        'flex-grow': 1,
        'background-color': 'white'
      }, this.leftContainerDivStyle);
    },
    modeButtonStyles(){
      return {
        bgColor: 'white',
        color: '#0072C5',
        selectedColor: 'black',
        selectedBorder: 'solid 1px black'
      };
    }
  },
  data: () => {
    return {

    }
  },
  mounted(){
  },
  methods: {
    buttonClick(e, button) {
      if(button.callback) {
        button.callback(button, e.target);
      }
    },
    selectButton(button) {
      button.style['color'] = this.modeButtonStyles.selectedColor;
    },
    unselectButton(button) {
      button.style['color'] = this.modeButtonStyles.color;

    }
  }
}
</script>